import { render, staticRenderFns } from "./delclient_homepage.vue?vue&type=template&id=cfd439aa&scoped=true&"
import script from "./delclient_homepage.vue?vue&type=script&lang=js&"
export * from "./delclient_homepage.vue?vue&type=script&lang=js&"
import style0 from "./delclient_homepage.vue?vue&type=style&index=0&id=cfd439aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd439aa",
  null
  
)

export default component.exports